import Icon from './Icons'
import { Edit, ItemHeading, ItemRow, ItemRowLabel, ModalItem, Title } from './BookingStepsContainer.styles'
import { Heading, Spacing } from '@big-red-group/storefront-common-ui'
import { ClickEventHandlerInput } from '@/types'

type BookingStepsContainerProps = {
  children: React.ReactNode
  index: number
  currentStep: number
  isDisabled: boolean
  onReset: () => void
  updateCurrentStep: (index: number) => void
  title?: string
  isDelayedCollapseEnabled?: boolean
  summary?: string | React.ReactNode
  dataTestId?: string
  hideUntil?: boolean
  onLinkClick?: (params: ClickEventHandlerInput) => void
}

const BookingStepsContainer: React.FC<BookingStepsContainerProps> = ({
  children,
  dataTestId,
  title,
  summary,
  onReset,
  index,
  currentStep,
  isDelayedCollapseEnabled,
  updateCurrentStep,
  isDisabled,
  hideUntil,
  onLinkClick,
}) => {
  if (hideUntil) {
    return <></>
  }
  const shouldCollapse = isDelayedCollapseEnabled ? index >= currentStep : index > currentStep
  const active = shouldCollapse || summary === undefined || summary === ''

  return (
    <ModalItem
      data-testid={dataTestId}
      className={isDisabled ? 'disabled' : ''}
      onClick={() => updateCurrentStep(index)}
      active={active}
    >
      {title && (
        <>
          <ItemHeading className="total-row" completed={!active}>
            <Heading size="XS" dataTestId="booking-step-title">
              {title}
            </Heading>
            <Icon name="confirmationGreen" width={20} height={20} />
          </ItemHeading>
          <Spacing size="S" />
        </>
      )}
      {active ? (
        <>{children}</>
      ) : (
        <ItemRow className="total-row">
          <ItemRowLabel data-testid="booking-step-summary">{summary}</ItemRowLabel>
          <Edit
            data-testid="edit-cart-item"
            onClick={(event) => {
              updateCurrentStep(index)
              onReset()
              if (onLinkClick) {
                const location = `PDP | Booking | ${title?.replace(/^\d+\.\s*/, '')}`
                onLinkClick({ url: window.location.href, location: location, event })
              }
            }}
          >
            Edit
          </Edit>
        </ItemRow>
      )}
    </ModalItem>
  )
}

export default BookingStepsContainer
